module.exports = __webpack_public_path__ + "static/credit-approval-ad5a15de6bba52e44e2c9442063a1edb.pdf";